import { render, staticRenderFns } from "./chooseBooking.vue?vue&type=template&id=10000ab4&"
import script from "./chooseBooking.vue?vue&type=script&lang=js&"
export * from "./chooseBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports